import { Link } from "react-router-dom";
import { ArrowLeft, ChevronRight, Network, Info } from "lucide-react";
import { OrganIcon } from "@/components/Shared";
import { ORGAN_PRESENTATION, ORGAN_ACCENTS } from "@/lib/organPresentation";
import OrganAnatomyVisual from "@/components/OrganAnatomyVisual";
export { ORGAN_ACCENTS } from "@/lib/organPresentation";

export function OrganHero({ organId, title, description, controls }) {
 const organ=ORGAN_PRESENTATION[organId];
 return <><Link to="/" className="dad-organ-back"><ArrowLeft size={16}/> Organismo</Link>
 <header className="dad-organ-hero" style={{"--organ-accent":ORGAN_ACCENTS[organId] || "#59dbea"}}>
  <div className="dad-organ-heading"><span className="dad-icon-orb"><OrganIcon icon={organ?.icon} size={28}/></span><div>
   <p className="dad-eyebrow">{organ?.anatomy} · metafora organismo</p>
   <h1 data-testid="organ-title">{title || organ?.title}</h1><p>{description}</p>
  </div></div>
  {controls && <div className="dad-organ-controls">{controls}</div>}
  <OrganAnatomyVisual organId={organId}/>
 </header></>;
}
export function PillarLinks({organId}) {
 return <aside className="dad-pillar-panel dad-panel"><h2><Network size={24}/> Collegamenti con i pilastri</h2><p>Esplora le funzioni collegate a questo organo.</p>
 <nav aria-label="Collegamenti con i pilastri">{(ORGAN_PRESENTATION[organId]?.connections || []).map(id=>{const o=ORGAN_PRESENTATION[id];return <Link key={id} to={o.route}><span className="dad-icon-orb" style={{"--organ-accent":ORGAN_ACCENTS[id] || "#59dbea"}}><OrganIcon icon={o.icon}/></span><span><strong>{o.name}</strong><small>{o.anatomy}</small></span><ChevronRight size={18}/></Link>;})}</nav>
 <p className="dad-pillar-note">Un unico organismo, informazioni che si parlano.</p></aside>;
}
export function OrganStatePanel({title,children,state="unknown"}) {
 return <section className="dad-organ-state dad-panel" data-state={state} role={state==="error"?"alert":"status"}><span className="dad-icon-orb"><Info size={28}/></span><div><h2>{title}</h2>{children}</div></section>;
}
export function OrganLayout({organId,title,description,controls,status,overview,children,...props}) {
 return <section className="dad-organ-page" {...props}><OrganHero organId={organId} title={title} description={description} controls={controls}/>{status && <div className="dad-organ-status-slot">{status}</div>}{overview && <div className="dad-organ-overview">{overview}</div>}<div className="dad-organ-workspace"><div className="dad-organ-content">{children}</div><PillarLinks organId={organId}/></div></section>;
}

export function OrganMetricsGrid({children,className="",...props}) {
 return <div className={"dad-organ-metrics-grid "+className} {...props}>{children}</div>;
}

export function OrganUnavailableView({organId,error=false}) {
 return <OrganLayout organId={organId} status={<OrganStatePanel title={error?"LETTURA NON DISPONIBILE":"CARICAMENTO"} state={error?"error":"loading"}><p>{error?"Impossibile leggere questo organo. Ricarica la pagina per riprovare.":"DAD sta collegando l’organo…"}</p></OrganStatePanel>}/>;
}
